import {
	AccommodationIcon,
	BusIcon,
	LandmarkIcon,
	MoreHorizIcon,
	ParkIcon,
	RestaurantIcon,
	ShoppingBagIcon,
	TicketIcon,
} from '@/assets/icons'
import type { EventCategory } from '@orbit/api-types'
import type React from 'react'

/** Each category's glyph — the web's stand-ins for the iOS symbols. */
export const CATEGORY_GLYPHS: Record<EventCategory, React.ElementType> = {
	FoodAndDrink: RestaurantIcon,
	SeeAndDo: LandmarkIcon,
	Nature: ParkIcon,
	Shopping: ShoppingBagIcon,
	Accommodation: AccommodationIcon,
	Transportation: BusIcon,
	Event: TicketIcon,
	Other: MoreHorizIcon,
}
